module.exports = __webpack_public_path__ + "img/ko.618a508a.png";